import React from "react";
import { ConversationsBubbleType } from "../../../../libraries/types_interface/chats/ChatsTypes";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { IconImageAsset } from "../../../../widget/common/ui/Icon";

const BubbleText: React.FC<ConversationsBubbleType> = ({
  message,
  autoReplayStatus,
  deleteLabel,
}) => {
  const messageText: string = UtilityHelper.fixEmoji(message);

  return (
    <div className="bubble-text">
      {UtilityHelper.isNotEmpty(deleteLabel ?? "") ? (
        <>
          <div className="font-size15_16 font-gotham-book color-black opacity-03 d-flex align-items-center">
            <span style={{ filter: "invert(1) hue-rotate(180deg)" }}>
              <IconImageAsset name="ban" size={12} />
            </span>
            <span className="ps-1">
              {deleteLabel === "you"
                ? "you deleted this message"
                : "this message was deleted"}
            </span>
          </div>
        </>
      ) : (
        <>
          {autoReplayStatus && (
            <div className="pb-2 font-size-14_15 font-gotham-bold color-black">
              {AppTranslation.text("auto_reply")}
            </div>
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: messageText.replaceAll("\n", "<br />"),
            }}
          />
        </>
      )}
    </div>
  );
};

export default BubbleText;
